import { metaMask } from '@wagmi/connectors';
import { createConfig, http } from '@wagmi/core';
import { mainnet, polygon } from '@wagmi/core/chains';

export const config = createConfig({
  chains: [mainnet, polygon],
  connectors: [metaMask()],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
  },
});
